import styles from './Abbr.module.scss';

export const Abbr = ({
  shortText,
  longText,
}: {
  shortText: string;
  longText: string;
}) => {
  return (
    <abbr title={longText} className={styles.Abbr}>
      {shortText}
    </abbr>
  );
};
